'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LockyTransparent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = require('./utils');

var _handleScroll = require('./handleScroll');

var _defaultEvents = require('./defaultEvents');

var _isInside = require('./isInside');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var groupTracker = {};

var EventLock = function (_Component) {
  _inherits(EventLock, _Component);

  function EventLock() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, EventLock);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EventLock.__proto__ || Object.getPrototypeOf(EventLock)).call.apply(_ref, [this].concat(args))), _this), _this.setRef = function (ref) {
      _this.ref = ref;
      if (ref) {
        if (!('scrollTop' in ref)) {
          // eslint-disable-next-line
          console.error('Locky: would not work for ', ref);
        }
      }
    }, _this.scrollWheel = function (event) {
      return (0, _handleScroll.handleScroll)(_this.ref, event, event.deltaY, _this.props.preventOnly);
    }, _this.scrollTouchStart = function (event) {
      _this.touchStart = (0, _handleScroll.getTouchY)(event);
    }, _this.scrollTouchMove = function (event) {
      return (0, _handleScroll.handleScroll)(_this.ref, event, _this.touchStart - (0, _handleScroll.getTouchY)(event), _this.props.preventOnly);
    }, _this.isEventInLock = function (event) {
      return _this.ref && (0, _isInside.isInside)(_this.ref, event.target);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EventLock, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props$group = this.props.group,
          group = _props$group === undefined ? '' : _props$group;

      if (!groupTracker[group]) {
        groupTracker[group] = [];
      }

      groupTracker[group].unshift(this);

      if (this.props.headless) {
        // eslint-disable-next-line
        this.setRef(_reactDom2.default.findDOMNode(this));
      }
      if (this.props.enabled) {
        this.enable();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this2 = this;

      if (this.props.enabled) {
        this.disable();
      }
      var group = this.props.group;

      if (group) {
        groupTracker[group] = groupTracker[group].filter(function (x) {
          return x !== _this2;
        });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(oldProps) {
      if (oldProps.enabled !== this.props.enabled) {
        if (this.props.enabled) {
          this.enable();
        } else {
          this.disable();
        }
      }
    }
  }, {
    key: 'enable',
    value: function enable() {
      var _this3 = this;

      var handlers = this.getEventHandlers();
      this.documentEvents = Object.keys(handlers).map(function (event) {
        return (0, _utils.addEvent)(document, event, _this3.getHandler(event, handlers[event]), true);
      }).filter(function (x) {
        return x;
      });

      this.nodeEvents = [];
      if (handlers.scroll) {
        var _nodeEvents;

        (_nodeEvents = this.nodeEvents).push.apply(_nodeEvents, [(0, _utils.addEvent)(this.ref, 'wheel', this.scrollWheel, true), (0, _utils.addEvent)(this.ref, 'touchstart', this.scrollTouchStart, true), (0, _utils.addEvent)(this.ref, 'touchmove', this.scrollTouchMove, true)]);
      }
    }
  }, {
    key: 'disable',
    value: function disable() {
      this.documentEvents.forEach(_utils.removeEvent);
      this.nodeEvents.forEach(_utils.removeEvent);
    }
  }, {
    key: 'getEventHandlers',
    value: function getEventHandlers() {
      var _props = this.props,
          noDefault = _props.noDefault,
          events = _props.events;

      return Object.assign({}, noDefault ? {} : _defaultEvents.EVENTS, events || {});
    }
  }, {
    key: 'getHandler',
    value: function getHandler(eventName, option) {
      var _this4 = this;

      var handler = (0, _utils.getHandler)(eventName, option, this.props.onEscape);
      if (handler) {
        return function (event) {
          if ((0, _isInside.shouldIgnoreEvent)(event.target)) {
            return;
          }
          var _props2 = _this4.props,
              leaded = _props2.leaded,
              _props2$group = _props2.group,
              group = _props2$group === undefined ? '' : _props2$group;

          if (!(0, _isInside.isInsideCurrent)(_this4.ref, event.target)) {
            if (leaded && group && ((0, _isInside.isLastInGroup)(_this4.ref) || groupTracker[group][0] === _this4) || !_this4.isEventInLock(event)) {
              handler(event);
            }
          }
        };
      }
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          component = _props3.component,
          group = _props3.group,
          className = _props3.className;

      var Node = component || _react2.default.createElement('div', null).type;

      return this.props.headless ? this.props.children : _react2.default.createElement(
        Node,
        { ref: this.setRef, 'data-locky-group': group, className: className },
        this.props.children
      );
    }
  }]);

  return EventLock;
}(_react.Component);

EventLock.propTypes = {
  noDefault: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  enabled: _propTypes2.default.bool,
  group: _propTypes2.default.string,
  leaded: _propTypes2.default.bool,
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  onEscape: _propTypes2.default.func,
  events: _propTypes2.default.objectOf(_propTypes2.default.oneOf([true, false, 'no-default', 'report', 'report-only'])),
  className: _propTypes2.default.string,
  preventOnly: _propTypes2.default.bool,
  headless: _propTypes2.default.bool
};
EventLock.defaultProps = {
  enabled: true,
  preventOnly: false
};
var LockyTransparent = exports.LockyTransparent = function LockyTransparent(_ref2) {
  var children = _ref2.children,
      _ref2$enabled = _ref2.enabled,
      enabled = _ref2$enabled === undefined ? true : _ref2$enabled;
  return _react2.default.createElement(
    'div',
    { 'data-locky-transparent': enabled },
    children
  );
};

LockyTransparent.propTypes = {
  children: _propTypes2.default.node,
  enabled: _propTypes2.default.bool
};

LockyTransparent.defaultProps = {
  enabled: true
};

exports.default = EventLock;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-locky/dist/index.js
// module id = 959
// module chunks = 58